import { useState } from 'react';
import { DateTimeUtils, LocalizedText, useDateTimeLocalizationInfo } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Container, IconName, Stack, TableHeader, Typography } from '@optimus-web/core';
import { LedgersDatePicker } from '../common/filters';
import { CityLedgerTable } from './components/CityLedgerTable';
import { ExportMenu } from './components/export/ExportMenu';
import { Filters } from './components/Filters';
import { WidgetCards } from './components/Widgets/WidgetCards';
import { useCityLedgerSelectedDate } from './context/CityLedgerFilterContext';
import { CityLedgerInvoicesProvider } from './context/CityLedgerMultipleInvoicesContext';

export const CityLedger = () => {
    const [isTableCollapsed, setIsTableCollapsed] = useState(true);
    const { selectedDate, setSelectedDate } = useCityLedgerSelectedDate();

    const localizationInfo = useDateTimeLocalizationInfo();
    const dateString = selectedDate && DateTimeUtils.dateIsoStringToDateString(selectedDate, localizationInfo);

    return (
        <Container overflowY="visible" position="relative">
            <LedgersDatePicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
            <WidgetCards />
            <CityLedgerInvoicesProvider>
                <Container padding={['400', '200']}>
                    <Stack vertical spacing="200">
                        <Stack distribution="space-between">
                            <TableHeader
                                title={<LocalizedText textKey={TextKey.CityLedger} />}
                                subTitle={
                                    dateString ? (
                                        <Typography
                                            data-test-id="city-ledger-table-subtitle"
                                            textStyle="titleMedium"
                                            variant="tertiary"
                                            as="span"
                                        >
                                            {dateString}
                                        </Typography>
                                    ) : null
                                }
                            />
                            <Stack spacing="100" itemAlignment="center">
                                <Button
                                    icon={isTableCollapsed ? IconName.CollapseAll : IconName.ExpandAll}
                                    iconPosition="left"
                                    variant="ghost"
                                    onClick={() => setIsTableCollapsed((prev) => !prev)}
                                    type="button"
                                >
                                    <LocalizedText
                                        textKey={isTableCollapsed ? TextKey.CollapseAll : TextKey.ExpandAll}
                                    />
                                </Button>
                                <Filters />
                                <ExportMenu />
                            </Stack>
                        </Stack>
                        <CityLedgerTable isTableCollapsed={isTableCollapsed} />
                    </Stack>
                </Container>
            </CityLedgerInvoicesProvider>
        </Container>
    );
};
